<template>
  <file-pond
    name="test"
    ref="pond"
    :label-idle="
      displayName ||
      'Drop files here or <span class=\'filepond--label-action\'>Browse</span>'
    "
    :allow-multiple="allowMultiple"
    :server="{ process }"
    :accepted-file-types="acceptedFileTypes"
    :allow-file-type-validation="onlyPdf"
  />
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import uploader from "../../mixins/uploader";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: "upload",
  mixins: [uploader],
  components: {
    FilePond,
  },
  computed: {
    acceptedFileTypes() {
      if (this.onlyPdf)
        return "application/pdf";
      else return ""
    }
  },
  props: {
    displayName: {
      type: String,
      required: false,
    },
    fileName: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
      // should be true in the future , base on input logic
    },
    allowMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlyPdf: {
      type: Boolean,
      required: false,
      default: false
    }
  },
};
</script>
